import React from 'react'
import { Badge } from 'design-system/Badge/Badge'

const FALLBACK_COLOR = '#475467'

// One vocabulary for both compares (and their report); stored values differ:
// CSV NEW/MODIFIED/ERROR, Ideon ADDED/REMOVED/MODIFIED.
export const COMPARE_STATUSES: Record<
  string,
  { label: string; color: string }
> = {
  NEW: { label: 'Added', color: '#879E4B' },
  ADDED: { label: 'Added', color: '#879E4B' },
  REMOVED: { label: 'Removed', color: '#CF5F57' },
  MODIFIED: { label: 'Changed', color: '#D7AD6A' },
  ERROR: { label: 'Error', color: '#CF5F57' },
}

export function compareStatusLabel(status: string): string {
  return COMPARE_STATUSES[status]?.label ?? status
}

export default function StatusBadge({ status }: { status: string }) {
  const known = COMPARE_STATUSES[status]
  return (
    <Badge
      color={known?.color ?? FALLBACK_COLOR}
      label={known ? known.label.toUpperCase() : status}
    />
  )
}
